import React, { useEffect, useState } from 'react';
import { isValid as isValidDate } from 'date-fns';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export const DatePicker = ({
  onChange,
  onBlur,
  onSelect,
  onClickOutside,
  onCalendarClose,
  placeholder = '',
  timestampValue = null,
  dateFormat = 'dd/MM/yyyy',
  inputClassName = '',
  id = '',
  minDate,
  maxDate,
}) => {
  const minimumDate = minDate ? { minDate } : {};
  const maximumDate = maxDate ? { maxDate } : {};
  const [dateValue, setDateValue] = useState();

  useEffect(() => {
    if (
      !timestampValue ||
      (timestampValue && !isValidDate(new Date(timestampValue)))
    ) {
      setDateValue(null);
      return;
    }

    setDateValue(new Date(timestampValue));
  }, [timestampValue]);

  const onChangeHandler = (selectedDate) => {
    onChange?.(selectedDate);
  };

  const onBlurHandler = () => {
    onBlur?.();
  };

  const onClickOutsideHandler = () => {
    onClickOutside?.();
  };

  const onSelectHandler = () => {
    onSelect?.();
  };

  const onCalendarCloseHandler = () => {
    onCalendarClose?.();
  };

  return (
    <ReactDatePicker
      {...minimumDate}
      {...maximumDate}
      id={id}
      dateFormat={dateFormat}
      selected={dateValue}
      placeholderText={placeholder}
      onChange={onChangeHandler}
      onBlur={onBlurHandler}
      onSelect={onSelectHandler}
      onClickOutside={onClickOutsideHandler}
      onCalendarClose={onCalendarCloseHandler}
      customInput={<input className={inputClassName} />}
    />
  );
};
